import { DefaultPageHeader } from 'layouts';
import type { OrganizationDetail } from 'models';
import { Card } from 'ui';
import { useGetOrganizationEntityBreadcrumb } from '../hooks';
import { OrganizationsCommunitiesList } from './organizations-communities-list';

type P = {
  getPathToCommunityDetail: (id: string) => string;
  organization: OrganizationDetail;
};

const OrganizationsCommunities = ({ getPathToCommunityDetail, organization }: P) => {
  const breadcrumbRoutes = useGetOrganizationEntityBreadcrumb({ entityType: 'communities', organization });

  return (
    <>
      <DefaultPageHeader routes={breadcrumbRoutes} title="Communities" />
      <Card>
        <OrganizationsCommunitiesList
          getPathToCommunityDetail={getPathToCommunityDetail}
          organizationId={organization.id}
        />
      </Card>
    </>
  );
};

export default OrganizationsCommunities;
